import * as types from "../types";

export const getModule = ({ idModule }) => ({
  type: types.GET_MODULE,
  request: {
    url: `course_modules/${idModule}`,
    method: "GET"
  }
});

export const updateModule = ({ idModule, completionPercentage }) => ({
  type: types.UPDATE_MODULE,
  request: {
    url: `course_modules/${idModule}/user_course_module`,
    method: "PATCH",
    data: {
      user_course_module: {
        completion_percentage: completionPercentage
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_MODULE]: ({ course_module: oldModule }) => {
        return {
          course_module: {
            ...oldModule,
            completion_percentage: completionPercentage
          }
        };
      }
    }
  }
});

export const getModuleQAs = ({ idModule }) => ({
  type: types.GET_MODULE_QAS,
  request: {
    url: `/course_modules/${idModule}/question_answers`,
    method: "GET"
  }
});

export const createModuleQuestion = ({ idModule, question }) => ({
  type: types.CREATE_MODULE_QA,
  request: {
    url: `/course_modules/${idModule}/question_answers`,
    method: "POST",
    data: {
      questionAnswer: {
        question
      }
    }
  },
  meta: {
    mutations: {
      [types.GET_MODULE_QAS]: (prevData, newData) => {
        return { ...prevData, data: [...prevData.data, newData.data] };
      }
    }
  }
});
